import { isAuth } from './authActions';
import {push} from "connected-react-router";
/*
 * action types
 */

export const ITEMS_IS_LOADING = 'ITEMS_IS_LOADING';
export const REQUEST_IS_PENDING = 'REQUEST_IS_PENDING';
export const ERROR_ALERT = 'ERROR_ALERT';
export const SUCCESS_ALERT = 'SUCCESS_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const WARNING_ALERT = 'WARNING_ALERT';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';

/*
 * action creators
 */

export const itemsIsLoading = bool => ({
	type: ITEMS_IS_LOADING,
	isLoading: bool,
});

export const requestIsPending = bool => ({
	type: REQUEST_IS_PENDING,
	isPending: bool,
});

export const receiveErrorAlert = errorAlert => ({
	type: ERROR_ALERT,
	alert: {
		status: 'danger',
		message: errorAlert
	}
});

export const receiveSuccessAlert = (successAlert, comment) => ({
	type: SUCCESS_ALERT,
	alert: {
		status: 'success',
		message: successAlert,
		comment : comment ? comment : null
	}
});

export const receiveWarningAlert = warningAlert => ({
	type: WARNING_ALERT,
	alert: {
		status: 'warning',
		message: warningAlert
	}
});

export const closeAlert = () => ({
	type: CLOSE_ALERT,
	alert: null
});

export const checkError = error => dispatch => {
	if (error.status === 401) {
		console.error('Unauthorize error (401): ', error);
		dispatch(isAuth(false));
		dispatch(push('/login'));
	} else if (error.status === 404) {
		dispatch(isAuth(false));
		dispatch(push('/404'));
		console.error('Not found error (404): ', error);
	} else if (error.status === 409) {
		console.error('Conflict: ', error);
	}
	// else if (error.status === 500) {
	// 	dispatch(isAuth(false));
	// 	dispatch(push('/500'));
	// 	console.error('Server error (500): ', error);
	// }
	else {
		console.error('Server error (500): ', error);
	}
	// throw new Error(error);
};

export const changeLanguage = lang => ({
	type: LANGUAGE_CHANGE,
	payload: {
		lang
	}
});



// WEBPACK FOOTER //
// ./src/actions/commonsActions.js